"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const callableObjectBuild = ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.PATH_ENTRIES]: pathEntries, }, }) => ((0, ts_validators_1.valueIsRecord)(pathEntries) ? pathEntries : {});
exports.default = callableObjectBuild;
